<mat-card-title style="font-size: 16px;">
  Transferir atendimento
</mat-card-title>

<form [formGroup]="formTroca">

  <div *ngIf="dados.User.nomeCliente == null" class="row justify-content-center">
      <p style="font-size: 11px;">Este Cliente ainda não esta associado a uma empresa.</p>
  </div>

    <div *ngIf="dados.User.idCliente == null" class="row justify-content-center">
      <div class="col-sm-8 col-12">
        <mat-form-field class="caixa-texto" style="width: 100%;">
          <mat-label>Nome da empresa</mat-label>
          <input formControlName="RazaoSocial" readonly matInput>
          <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="buscarEmpresa()">
            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-search" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z" />
              <path fill-rule="evenodd"
                d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z" />
            </svg>
          </button>
        </mat-form-field>
      </div>
    </div>


  <div class="row justify-content-center">
    <div class="col-sm-8 col-12">
    <mat-form-field style="margin-left: 5px; width:100%">
      <mat-label>Selecione uma equipe.</mat-label>
      <mat-select formControlName="novaEquipe">
        <mat-option *ngFor="let option of SelectEquipes" [value]="option">
          {{option.nomeEquipe}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    </div>
  </div>

  <div class="row justify-content-end">
    <button mat-raised-button style="line-height: 30px !important;" color="primary"
      (click)="confirmaTroca()">Enviar</button>
  </div>
</form>